import { useCallback, useEffect, useState } from "react";

type SpaceQueryOptions = {
    initialCategory?: string;
    initialSearch?: string;
    debounceMs?: number;
};

export function useSpaceQueryState({ initialCategory = "All", initialSearch = "", debounceMs = 0 }: SpaceQueryOptions = {}) {
    const normalizedInitialSearch = initialSearch.trim();
    const [searchInput, setSearchInput] = useState(normalizedInitialSearch);
    const [searchQuery, setSearchQuery] = useState(normalizedInitialSearch);
    const [category, setCategory] = useState(initialCategory);

    useEffect(() => {
        const normalized = searchInput.trim();
        if (debounceMs <= 0) {
            setSearchQuery(normalized);
            return;
        }
        const timer = window.setTimeout(() => setSearchQuery(normalized), debounceMs);
        return () => window.clearTimeout(timer);
    }, [debounceMs, searchInput]);

    const reset = useCallback(() => {
        setSearchInput("");
        setSearchQuery("");
        setCategory(initialCategory);
    }, [initialCategory]);

    return {
        searchInput,
        searchQuery,
        setSearchInput,
        category,
        setCategory,
        isFiltered: Boolean(searchQuery) || category !== initialCategory,
        reset,
    };
}
